import Vue from 'vue'
import Vuex from 'vuex'
import DataStorage from './modules/DataStorage'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    DataStorage
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js